/**
 * Product Page Enhancements
 * Gestion de la barre de reservation sticky et tracking GTM
 */

$(function() {
    // Skip if not on product page
    if (!$('body.detail-page').length) return;

    // =========================================
    // 1. Floating booking bar (sticky)
    // =========================================
    var $floatingBar = $('#floating-booking');
    if ($floatingBar.length) {
        var $hero = $('#main-header.hero-product');
        var heroHeight = $hero.length ? $hero.outerHeight() : 400;

        $(window).on('scroll', function() {
            if ($(window).scrollTop() > heroHeight - 100) {
                $floatingBar.addClass('visible');
            } else {
                $floatingBar.removeClass('visible');
            }
        });
    }

    // =========================================
    // 2. Track booking clicks (GTM)
    // =========================================
    $(document).on('click', '[data-trk-booking]', function() {
        var activityName = $(this).data('trk-booking');
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'booking_click',
                'activity_name': activityName,
                'click_location': $(this).closest('.hero-product').length ? 'hero' :
                                  $(this).closest('.floating-booking-bar').length ? 'floating_bar' :
                                  $(this).closest('.booking-cta-box').length ? 'booking_section' : 'other'
            });
        }
    });

    // =========================================
    // 3. Smooth scroll pour les pills du hero
    // =========================================
    $(document).on('click', '.hero-pills .pill[data-scroll-to]', function(e) {
        e.preventDefault();
        var target = $(this).data('scroll-to');
        if (target && $(target).length) {
            $('html, body').animate({
                scrollTop: $(target).offset().top - 100
            }, 500);
        }
    });

    // =========================================
    // 4. Animation du scroll indicator
    // =========================================
    $(document).on('click', '.scroll-indicator', function() {
        var $nextSection = $('#main-header').next('section');
        if ($nextSection.length) {
            $('html, body').animate({
                scrollTop: $nextSection.offset().top
            }, 600);
        }
    });

});
